import {
  type CLSMetric,
  type FCPMetric,
  type INPMetric,
  type LCPMetric,
  onCLS,
  onFCP, onINP, onLCP, onTTFB,
  type TTFBMetric,
} from 'web-vitals'
import type { RouteLocationNormalizedGeneric } from 'vue-router'

const DB_NAME = 'WebVitalsDB'
const STORE_NAME = 'VitalsStore'
let cachedDB: IDBDatabase | null = null

async function getCachedDB(): Promise<IDBDatabase> {
  if (cachedDB) return cachedDB
  cachedDB = await openDB()
  return cachedDB
}
function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1)
    request.onerror = () => reject(request.error)
    request.onsuccess = () => resolve(request.result)
    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' })
      }
    }
  })
}
export async function getAllMetricsFromDB(): Promise<any[]> {
  const db = await getCachedDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly')
    const store = tx.objectStore(STORE_NAME)
    const req = store.getAll()
    req.onsuccess = () => resolve(req.result)
    req.onerror = () => reject(req.error)
  })
}
function get30DaysAgoTimestamp(): string {
  const date = new Date()
  date.setDate(date.getDate() - 30)
  return date.toISOString()
}
// 清除早于 30 天的数据
async function cleanupOldMetrics(db: IDBDatabase): Promise<void> {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite')
    const store = tx.objectStore(STORE_NAME)
    const request = store.getAll()

    request.onsuccess = () => {
      const thirtyDaysAgo = get30DaysAgoTimestamp()
      const oldItems = request.result.filter((item: any) => item.timestamp < thirtyDaysAgo)
      oldItems.forEach((item: any) => {
        store.delete(item.id)
      })
      resolve()
    }
    request.onerror = () => reject(request.error)
  })
}

async function maybeCleanupOldMetrics(db: IDBDatabase) {
  const lastCleanup = localStorage.getItem('web-vitals-cleanup-ts')
  const now = Date.now()
  if (!lastCleanup || now - Number(lastCleanup) > 1000 * 60 * 60 * 24) {
    await cleanupOldMetrics(db)
    localStorage.setItem('web-vitals-cleanup-ts', String(now))
  }
}

interface Opts {
  fullPath?:string,
  href?:string,
}
export async function saveMetricToDB(opts:Opts,metric: CLSMetric  | LCPMetric | INPMetric | TTFBMetric | FCPMetric ) {
  const db = await getCachedDB()
  await maybeCleanupOldMetrics(db)
  const tx = db.transaction(STORE_NAME, 'readwrite')
  const store = tx.objectStore(STORE_NAME)
  let entriesStr
  try {
    entriesStr = JSON.stringify(metric.entries)
  } catch (e) {
    console.error(e)
    entriesStr = 'JSON.stringify error'
  }
  const timestamp = new Date().toISOString()
  store.put({
    timestamp,
    ...opts,
    ...metric,
    entries: entriesStr,
  })
  // tx.oncomplete = () => db.close() 
}

export function sendVitals(to:RouteLocationNormalizedGeneric) {
  if (to.path.includes('web-vitals-report')) {
    return
  }
  const handlers = [
    onCLS,
    onFCP,
    onLCP,
    onINP,
    onTTFB
  ]
  handlers.forEach(fn => {
    fn((metric) => {
      saveMetricToDB({
        fullPath:to.fullPath,
        href:location.href,
      },metric)
    })
  })
}